import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackPixel } from '../lib/pixel.js';

const COLUMNS = [
  {
    heading: 'Quick Links',
    links: [
      { label: 'Home',        to: '/' },
      { label: 'About Us',    to: '/about' },
      { label: 'Gift a Lecture', href: 'https://linktr.ee/thedrunkenlectures' },
      { label: 'Contact',       to: '/contact' },
      { label: 'Gallery',       to: '/gallery' },
      { label: 'Partnerships',  to: '/partnerships' },
    ],
  },
  {
    heading: 'Lectures',
    links: [
      { label: 'Read past lectures',     to: '/lectures' },
      { label: 'Join the newsletter',    href: 'https://drunkenlectures.com/newsletter' },
      { label: 'Attend a lecture',       href: 'https://linktr.ee/thedrunkenlectures' },
      { label: 'Watch a past lecture',   href: 'https://www.youtube.com/@Lecturacollective' },
      { label: 'Apply to be a lecturer', href: 'https://docs.google.com/forms/d/e/1FAIpQLSfbNl_W_G5j_wqZFR-uegCgLoOyiKBjytkuuNDcP8jZDy2d1A/viewform' },
    ],
  },
  {
    heading: 'Our Merch',
    links: [
      { label: 'Shop the drop', to: '/merch' },
      { label: 'Shirts',        to: '/merch' },
      { label: 'Hats',          to: '/merch' },
      { label: 'Bags',          to: '/merch' },
      { label: 'Badges',        to: '/merch' },
    ],
  },
  {
    heading: 'Get Started',
    links: [
      { label: 'Corporate / Partner with Us', to: '/partnerships' },
    ],
  },
];

const inputStyle = {
  width: '100%',
  background: 'transparent',
  border: '1px solid rgba(255,255,255,0.2)',
  borderRadius: '4px',
  padding: '0.75rem 1rem',
  color: 'white',
  fontSize: '0.92rem',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s ease',
};

function NewsletterForm() {
  const [email,   setEmail]   = useState('');
  const [name,    setName]    = useState('');
  const [status,  setStatus]  = useState('idle'); // idle | loading | success | error
  const [focused, setFocused] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');

    try {
      const res = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/subscribe-newsletter`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          },
          body: JSON.stringify({ email: email.trim(), name: name.trim() }),
        }
      );

      if (res.ok) {
        setStatus('success');
        trackPixel('Lead', { content_name: 'Newsletter' });
        setEmail('');
        setName('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div style={{ minWidth: '280px', maxWidth: '360px' }}>
      <h4 style={{
        fontSize: '0.72rem', fontWeight: '700', letterSpacing: '0.1em',
        color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase',
        margin: '0 0 1.25rem',
      }}>
        Newsletter
      </h4>

      <p style={{ fontSize: '1.4rem', fontWeight: '700', lineHeight: 1.2, margin: '0 0 0.75rem', color: 'white' }}>
        Let's get in touch
      </p>
      <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)', margin: '0 0 1.5rem', lineHeight: 1.5 }}>
        Join our newsletter and be the first to discover new things.
      </p>

      {status === 'success' ? (
        <p style={{ color: '#E8672E', fontSize: '0.92rem', fontWeight: '600' }}>
          You're in! Welcome to Drunken Lectures.
        </p>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <input
            type="email"
            placeholder="Enter your email address..."
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{
              ...inputStyle,
              borderColor: focused === 'email' ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.2)',
            }}
            onFocus={() => setFocused('email')}
            onBlur={() => setFocused(null)}
          />
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={e => setName(e.target.value)}
            style={{
              ...inputStyle,
              borderColor: focused === 'name' ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.2)',
            }}
            onFocus={() => setFocused('name')}
            onBlur={() => setFocused(null)}
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            style={{
              background: 'white',
              color: '#111111',
              border: 'none',
              borderRadius: '4px',
              padding: '0.75rem 1rem',
              fontSize: '0.92rem',
              fontWeight: '700',
              cursor: status === 'loading' ? 'not-allowed' : 'pointer',
              opacity: status === 'loading' ? 0.7 : 1,
              transition: 'opacity 0.2s ease, background 0.2s ease',
              letterSpacing: '0.02em',
            }}
            onMouseEnter={e => { if (status !== 'loading') e.currentTarget.style.background = '#E8672E'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = '#111111'; }}
          >
            {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
          </button>
          {status === 'error' && (
            <p style={{ color: '#ff4d4d', fontSize: '0.82rem', margin: 0 }}>
              Something went wrong. Please try again.
            </p>
          )}
        </form>
      )}
    </div>
  );
}

export default function Footer() {
  const linkStyle = {
    color: 'rgba(255,255,255,0.65)',
    textDecoration: 'none',
    fontSize: '0.92rem',
    transition: 'color 0.2s ease',
    lineHeight: 1.4,
  };

  return (
    <footer style={{ background: '#111111', color: 'white', padding: '4.5rem 1.5rem 2rem' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

        <div style={{ marginBottom: '3rem' }}>
          <img
            loading="lazy"
            decoding="async"
            src="/Assets/logo.png"
            alt="Drunken Lectures"
            style={{ height: '40px', width: 'auto', filter: 'brightness(0) invert(1)', opacity: 0.9 }}
          />
        </div>

        <div style={{
          display: 'flex',
          gap: '4rem',
          marginBottom: '3.5rem',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
        }}>
          {/* Link columns */}
          <div style={{
            flex: '1 1 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '3rem',
          }}>
            {COLUMNS.map((col) => (
              <div key={col.heading}>
                <h4 style={{
                  fontSize: '0.72rem', fontWeight: '700', letterSpacing: '0.1em',
                  color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase',
                  marginBottom: '1.25rem', margin: '0 0 1.25rem',
                }}>
                  {col.heading}
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
                  {col.links.map(({ label, to, href }) =>
                    href ? (
                      <a
                        key={label}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={linkStyle}
                        onMouseEnter={e => { e.currentTarget.style.color = '#E8672E'; }}
                        onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}
                      >
                        {label}
                      </a>
                    ) : to === '#' ? (
                      <a
                        key={label}
                        href="#"
                        style={linkStyle}
                        onMouseEnter={e => { e.currentTarget.style.color = '#E8672E'; }}
                        onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}
                      >
                        {label}
                      </a>
                    ) : (
                      <Link
                        key={label}
                        to={to}
                        style={linkStyle}
                        onMouseEnter={e => { e.currentTarget.style.color = '#E8672E'; }}
                        onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}
                      >
                        {label}
                      </Link>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Newsletter — right side */}
          <div style={{ flex: '0 1 auto', minWidth: 0 }}>
            <NewsletterForm />
          </div>
        </div>

        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)',
          paddingTop: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem',
          fontSize: '0.85rem',
          color: 'rgba(255,255,255,0.35)',
        }}>
          <span>© 2026 Drunken Lectures. All rights reserved.</span>
          <a href="https://thecausality.agency" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: 'rgba(255,255,255,0.35)' }}>
            Powered by
            <img loading="lazy" decoding="async" src="/Assets/causality-logo.png" alt="The Causality" style={{ height: '22px', width: 'auto', opacity: 0.75 }} />
          </a>
        </div>

      </div>
    </footer>
  );
}
